module.exports = __webpack_public_path__ + "static/people-22146f9f7a612c7b879f0e5a3d2fe11c.png";